// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b10c4f1a","977":"2879dc8c"}[chunkId] + ".chunk.js";
};